(() => {
  if (window.zbAtelierReady) return;
  window.zbAtelierReady = true;
  const key = 'zb-saved-pieces-v1';
  const dialog = document.getElementById('ZbAtSaved');
  const status = document.querySelector('[data-at-live]');
  let saved = [];
  let returnFocus;
  let overflow;
  try { const value = JSON.parse(localStorage.getItem(key) || '[]'); if (Array.isArray(value)) saved = value.filter(p => p && typeof p.handle === 'string' && typeof p.url === 'string' && p.url.startsWith('/products/')).slice(0, 50); } catch (_) {}
  function update() {
    document.querySelectorAll('[data-at-save]').forEach(button => button.setAttribute('aria-pressed', String(saved.some(p => p.handle === button.dataset.handle))));
    document.querySelectorAll('[data-at-saved-count]').forEach(count => { count.textContent = String(saved.length); count.hidden = !saved.length; });
  }
  function persist() {
    try { localStorage.setItem(key, JSON.stringify(saved)); } catch (_) { if (status && dialog) status.textContent = dialog.dataset.error; }
    update();
  }
  function render() {
    if (!dialog) return;
    const container = dialog.querySelector('[data-at-saved-items]');
    container.replaceChildren();
    if (!saved.length) {
      const empty = document.createElement('div'); empty.className = 'zb-at-saved__empty';
      const heading = document.createElement('h3'); heading.textContent = dialog.dataset.empty;
      const hint = document.createElement('p'); hint.textContent = dialog.dataset.hint;
      empty.append(heading, hint); container.append(empty); return;
    }
    saved.forEach(piece => {
      const article = document.createElement('article');
      const link = document.createElement('a'); link.href = piece.url;
      const image = document.createElement('img'); image.src = piece.image; image.alt = piece.title; image.width = 240; image.height = 240; image.loading = 'lazy';
      const name = document.createElement('h3'); name.textContent = piece.title;
      const price = document.createElement('p'); price.textContent = piece.price;
      const remove = document.createElement('button'); remove.type = 'button'; remove.dataset.atRemove = piece.handle; remove.textContent = dialog.dataset.remove;
      link.append(image, name); article.append(link, price, remove); container.append(article);
    });
  }
  document.addEventListener('click', event => {
    const save = event.target.closest('[data-at-save]');
    if (save) {
      event.preventDefault(); event.stopPropagation();
      const index = saved.findIndex(piece => piece.handle === save.dataset.handle);
      if (index >= 0) saved.splice(index, 1);
      else { const d = save.dataset; saved.unshift({ handle: d.handle, title: d.title, url: d.url, image: d.image, price: d.price }); saved = saved.slice(0, 50); }
      persist(); return;
    }
    const open = event.target.closest('[data-at-open-saved]');
    if (open && dialog) { returnFocus = open; overflow = document.body.style.overflow; render(); dialog.showModal(); document.body.style.overflow = 'hidden'; return; }
    if (event.target.closest('[data-at-close-saved]')) { dialog?.close(); return; }
    const remove = event.target.closest('[data-at-remove]');
    if (remove) { saved = saved.filter(piece => piece.handle !== remove.dataset.atRemove); persist(); render(); return; }
    const scroll = event.target.closest('[data-at-scroll]');
    if (scroll) {
      const rail = scroll.closest('.zbh-featured')?.querySelector('[data-at-rail]');
      rail?.scrollBy({ left: Number(scroll.dataset.atScroll) * rail.clientWidth * .8, behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth' });
    }
  });
  dialog?.addEventListener('close', () => { document.body.style.overflow = overflow || ''; returnFocus?.focus(); });
  dialog?.addEventListener('click', event => { if (event.target !== dialog) return; const r = dialog.getBoundingClientRect(); if (event.clientX < r.left || event.clientX > r.right || event.clientY < r.top || event.clientY > r.bottom) dialog.close(); });
  window.addEventListener('storage', event => { if (event.key !== key) return; try { const next = JSON.parse(event.newValue || '[]'); if (Array.isArray(next)) { saved = next; update(); if (dialog?.open) render(); } } catch (_) {} });
  const scope = document.querySelector('main');
  if (scope) new MutationObserver(records => { if (records.some(record => [...record.addedNodes].some(node => node.nodeType === 1 && (node.matches('[data-at-save]') || node.querySelector('[data-at-save]'))))) update(); }).observe(scope, { childList: true, subtree: true });
  update();
})();
